export default function(info){
    throw new Error(info);
}